import { useQueryClient } from '@tanstack/react-query'

import { Icon } from '@/components/ui/Icon'
import { formatTime } from '@/lib/format'
import { useNetworkStatus } from '@/lib/online'
import { usePendingCount } from '@/offline/queue'

/**
 * Полоса «Офлайн · N не отправлено · данные на ЧЧ:ММ». Время — самый свежий загруженный
 * ответ, если не передано. Записывать без связи можно только тренировку (очередь).
 */
export function OfflineBanner({ online, dataAt }: { online?: boolean; dataAt?: Date | null }) {
  const browserOnline = useNetworkStatus()
  const pending = usePendingCount()
  const queryClient = useQueryClient()
  const isOnline = online ?? browserOnline
  if (isOnline) return null

  let at = dataAt ?? null
  if (at === undefined || at === null) {
    const latest = Math.max(0, ...queryClient.getQueryCache().getAll().map((q) => q.state.dataUpdatedAt))
    at = latest > 0 ? new Date(latest) : null
  }

  const parts = ['Офлайн']
  if (pending > 0) parts.push(`${pending} не отправлено`)
  parts.push(at ? `данные на ${formatTime(at)}` : 'показаны последние загруженные данные')

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 border-b border-warning/30 bg-warning-soft px-4 py-2 text-center text-sm text-warning"
    >
      <Icon name="wifi-off" size={16} />
      <span>{parts.join(' · ')}</span>
      <span className="text-xs">Сохранить изменения сейчас можно только в тренировке</span>
    </div>
  )
}
